import {
  type TCategoryDictionary,
  type TCategoryDictionaryApi,
  type TCategoryDictionaryDto,
  type TCategoryDictionaryForm
} from '@/components/AdminPanel/Directory/types/categories.types';
import { convertActiveStatus } from '@/components/AdminPanel/Shared/helpers/convertActiveStatus';

export const categoriesDirectoryMapperFromApi = (
  category: TCategoryDictionaryApi
): TCategoryDictionary => {
  return {
    code: category.code,
    isActive: convertActiveStatus.toStr(category.is_active),
    modulesSupportCategories: category.Modules_Support_Categories,
    name: category.name,
    uuid: category.uuid
  };
};

export const categoriesDirectoryMapperToForm = (
  category: TCategoryDictionary
): TCategoryDictionaryForm => {
  return {
    code: category.code,
    isActive: category.isActive,
    modulesSupportCategories: category.modulesSupportCategories.map(
      (item) => item.module.uuid
    ),
    name: category.name,
    uuid: category.uuid
  };
};

export const categoriesDirectoryMapperToDto = (
  category: TCategoryDictionaryForm
): TCategoryDictionaryDto => {
  return {
    code: category.code,
    is_active: convertActiveStatus.toBoolean(category.isActive),
    modules: category.modulesSupportCategories,
    name: category.name,
    uuid: category.uuid
  };
};
